enum EOptionKey {
  relevance = "relevance",
  low = "low",
  high = "high",
  rate = "rate",
  nameAZ = "nameAZ",
  nameZA = "nameZA",
}

export default EOptionKey;
